var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "unscheduledClassesModal",
        maximized: _vm.maximized,
        value: _vm.unscheduledClassesModal
      },
      on: {
        hide: function($event) {
          _vm.closeModal("unscheduledClasses")
        }
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "fa fa-clock-o" } }),
                  _vm._v("Unscheduled Classes Report\n    ")
                ],
                1
              ),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeModal("unscheduledClasses")
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticStyle: { padding: "40px 20px" } }, [
            _c("div", { staticClass: "sl-row" }, [
              _c("div", { staticClass: "sl-col-12" }, [
                _c(
                  "p",
                  {
                    staticClass: "text-center",
                    staticStyle: { "max-width": "350px", margin: "0 auto" }
                  },
                  [
                    _vm._v("This report shows all agencies who do "),
                    _c("b", [_vm._v("not")]),
                    _vm._v(
                      " have classes scheduled within the specified date range."
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "sl-row", staticStyle: { margin: "0" } }, [
              _c(
                "div",
                { staticClass: "sl-col-6" },
                [
                  _c("q-datetime", {
                    attrs: { "stack-label": "Start Date *" },
                    model: {
                      value: _vm.startDate,
                      callback: function($$v) {
                        _vm.startDate = $$v
                      },
                      expression: "startDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sl-col-6" },
                [
                  _c("q-datetime", {
                    attrs: { "stack-label": "End Date *" },
                    model: {
                      value: _vm.endDate,
                      callback: function($$v) {
                        _vm.endDate = $$v
                      },
                      expression: "endDate"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                attrs: { color: "green", icon: "fa fa-play", label: "Run" },
                nativeOn: {
                  click: function($event) {
                    _vm.runReport()
                  }
                }
              }),
              _vm._v(" \n      "),
              _c("q-btn", {
                attrs: { outline: "", color: "faded", label: "Cancel" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeModal("unscheduledClasses")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }